module.exports = __webpack_public_path__ + "static/media/back-yellow.e4dca0f0.png";